/// <reference path="../../../../scripts/typings/jquery/jquery.d.ts" />
/// <reference path="../../../../scripts/typings/q/q.d.ts" />
define('areas/informationrequest/service/dataCollectionClient',["require", "exports", "models/account", "services/jsonconverter", "services/settings"], function (require, exports, Account, JsonConverter, configuration) {
    "use strict";
    var Channel = (function () {
        function Channel(convertToCamelCase) {
            if (convertToCamelCase === void 0) { convertToCamelCase = true; }
            this._convertToCamelCase = convertToCamelCase;
        }
        Channel.prototype.getData = function (url) {
            return this.send(url, "GET", null, false);
        };
        Channel.prototype.getDataAsync = function (url) {
            return Q(this.send(url, "GET", null, true));
        };
        Channel.prototype.postData = function (url, data) {
            return this.send(url, "POST", data, false);
        };
        Channel.prototype.postDataAsync = function (url, data, customBaseUrl) {
            return Q(this.send(url, "POST", data, true, customBaseUrl));
        };
        Channel.prototype.putData = function (url, data) {
            return this.send(url, "PUT", data, false);
        };
        Channel.prototype.putDataAsync = function (url, data) {
            return Q(this.send(url, "PUT", data, true));
        };
        Channel.prototype.deleteData = function (url, data) {
            return this.send(url, "DELETE", data, false);
        };
        Channel.prototype.deleteDataAsync = function (url, data) {
            return Q(this.send(url, "DELETE", data, true));
        };
        Channel.prototype.getAjaxOptions = function (type, data, async) {
            var contentType = 'application/json';
            if (data != null && typeof data == "string") {
                contentType = 'text/plain';
            }
            var options = {
                async: async,
                context: this,
                type: type,
                accept: contentType,
                contentType: contentType,
                beforeSend: function (req) {
                    if (Account.Session.isAuthenticated) {
                        req.setRequestHeader("Authorization", Account.Session.getAuthorizationHeader());
                    }
                }
            };
            if (data != null) {
                if (typeof data == "string") {
                    options.data = data;
                }
                else {
                    if (typeof data.name == "string") {
                        var formData = new FormData();
                        formData.append("file", data);
                        options.data = formData;
                        options.processData = false;
                        options.contentType = false;
                        options.contentDisposition = "form-data; filename='" + data.name + "'";
                    }
                    else {
                        options.data = JSON.stringify(data);
                    }
                }
            }
            return options;
        };
        Channel.prototype.send = function (url, type, data, async, customBaseUrl) {
            var converter = new JsonConverter();
            var target = this.makeUrl(url, customBaseUrl);
            //var content = converter.extend(data, null);
            //content = converter.convertPropertyNamesToPascalCase(content);
            var options = this.getAjaxOptions(type, data, async);
            var response = jQuery.ajax(target, options);
            response.then(function (result) {
                return result;
            });
            return response;
        };
        Channel.prototype.makeUrl = function (url, customBaseUrl) {
            var baseApiUrl;
            if (customBaseUrl) {
                baseApiUrl = configuration.Settings.environment.getCustomValue(customBaseUrl);
            }
            else {
                baseApiUrl = configuration.Settings.environment.getCustomValue("CCHDataCollection");
            }
            var domain = configuration.Settings.getPortalDomain();
            return baseApiUrl.replace("api", domain) + url;
        };
        return Channel;
    }());
    exports.Channel = Channel;
});

